import { gql } from "@apollo/client";
import { RealtimeAggregatePageResult } from "../types/RealtimeInvoiceType";

export const GET_REALTIME_DAILY_AGGREGATES = gql`
    query GetRealtimeDailyAggregates(
        $settlementClientId: ID!
        $dateFrom: Int
        $dateTo: Int
        $page: Int!
        $size: Int!
    ) {
        getRealtimeDailyAggregates(
            settlementClientId: $settlementClientId
            dateFrom: $dateFrom
            dateTo: $dateTo
            page: $page
            size: $size
        ) {
            success
            code
            message
            content {
                aggregateId
                businessDate
                deliveredCount
                returnedCount
                orderCount
                totalAmount
                invoicedAmount
                remainingAmount
                fundPoolId
                currency
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export interface GetRealtimeDailyAggregatesResponse {
    getRealtimeDailyAggregates: RealtimeAggregatePageResult;
}
